import type { Report } from 'corso-admin-ui';
import { productReasonTables, reasonTables } from '../claimItems';
import { warrantyReasonCharts } from '../reasonCharts';

export const reasons = {
  key: 'reasons',
  label: 'Reasons',
  dataset: 'claimItems',
  timeFields: ['createdOn'],
  widgets: [...warrantyReasonCharts, ...reasonTables, ...productReasonTables],
} as const satisfies Report;
